export default __webpack_public_path__ + "static/media/VeeNee-powder-coating.ca8971c5.webp";